/* ============================================================
   Bedtextielonline — collectie-keuzehulp
   assets/btol-wizard.js

   De gedeelde motor. Bevat GEEN collectie-specifieke inhoud.
   Elke collectie zet zijn eigen config in window.BTOL_WIZARD via
   een eigen Custom Liquid blok. Staat er geen config, dan gebeurt
   er niets.

   Wat je hier aanpast, geldt voor alle wizards tegelijk.
   ============================================================ */

(function () {
  'use strict';

  var VERSION = '2026-07-15-j';
  var btolT = function (k, d, v, ruw) { var s = (window.BTOL_T && window.BTOL_T[k]) || d; if (!ruw && !/_html$/.test(k)) s = String(s).replace(/&(#39|#x27|quot|lt|gt|amp);/g, function (m, e) { return { '#39': "'", '#x27': "'", quot: '"', lt: '<', gt: '>', amp: '&' }[e]; }); if (v) Object.keys(v).forEach(function (n) { s = String(s).split('{' + n + '}').join(v[n]); }); return s; };

  var AVAIL_KEY  = 'filter.v.availability';
  var SCROLL_KEY = 'btol_scroll_to_results';
  var POS_KEY    = 'btol_wiz_offset';
  var SKIP_KEY   = 'btol_skipped_steps';
  var USED_KEY   = 'btol_used';
  var SENT_KEY   = 'btol_sent';
  var SCROLL_BREATH = 0; // 0 = onderkant wizard exact tegen de header; hoger = strookje wizard blijft zichtbaar

  /* ==========================================================
     ICONENBIBLIOTHEEK
     Gebruik in een config met  icon:'katoen'
     ========================================================== */

  var ICONS = {
    bed1: '<svg width="30" height="21" viewBox="0 0 48 32" fill="none"><path d="M14 12c0-3 2-5 5-5h10c3 0 5 2 5 5v2H14v-2Z" stroke-width="1.8"/><path d="M10 18h28v6H10v-6Z" stroke-width="1.8"/><path d="M12 24v5M36 24v5" stroke-width="1.8"/></svg>',
    bed2: '<svg width="30" height="21" viewBox="0 0 48 32" fill="none"><path d="M8 14c0-3 2-5 5-5h6c3 0 5 2 5 5v2H8v-2Z" stroke-width="1.8"/><path d="M24 14c0-3 2-5 5-5h6c3 0 5 2 5 5v2H24v-2Z" stroke-width="1.8"/><path d="M6 18h36v6H6v-6Z" stroke-width="1.8"/><path d="M8 24v5M40 24v5" stroke-width="1.8"/></svg>',
    bed3: '<svg width="30" height="21" viewBox="0 0 48 32" fill="none"><path d="M6 14c0-3 2-5 5-5h6c3 0 5 2 5 5v2H6v-2Z" stroke-width="1.8"/><path d="M28 14c0-3 2-5 5-5h6c3 0 5 2 5 5v2H28v-2Z" stroke-width="1.8"/><path d="M4 18h40v6H4v-6Z" stroke-width="1.8"/><path d="M6 24v5M42 24v5" stroke-width="1.8"/></svg>',
    bed4: '<svg width="30" height="21" viewBox="0 0 48 32" fill="none"><path d="M4 14c0-3 2-5 5-5h6c3 0 5 2 5 5v2H4v-2Z" stroke-width="1.8"/><path d="M30 14c0-3 2-5 5-5h6c3 0 5 2 5 5v2H30v-2Z" stroke-width="1.8"/><path d="M2 18h44v6H2v-6Z" stroke-width="1.8"/><path d="M4 24v5M44 24v5" stroke-width="1.8"/></svg>',

    matras:      '<svg width="30" height="21" viewBox="0 0 48 32" fill="none"><rect x="4" y="12" width="40" height="12" rx="3" stroke-width="1.8"/><path d="M4 18h40" stroke-width="1.2"/></svg>',
    topper:      '<svg width="30" height="21" viewBox="0 0 48 32" fill="none"><rect x="4" y="19" width="40" height="8" rx="2.5" stroke-width="1.8"/><path d="M9 14h30" stroke-width="1.4"/><path d="M13 9h22" stroke-width="1.4"/></svg>',
    duosplit:    '<svg width="30" height="21" viewBox="0 0 48 32" fill="none"><rect x="4" y="12" width="40" height="12" rx="3" stroke-width="1.8"/><path d="M24 12v3.5M24 20.5V24" stroke-width="1.8"/></svg>',
    splittopper: '<svg width="30" height="21" viewBox="0 0 48 32" fill="none"><rect x="4" y="18" width="40" height="9" rx="2.5" stroke-width="1.8"/><path d="M24 18v9" stroke-width="1.8"/><path d="M11 13h26" stroke-width="1.4"/></svg>',
    dun:         '<svg width="30" height="21" viewBox="0 0 48 32" fill="none"><rect x="7" y="15" width="34" height="8" rx="2.5" stroke-width="1.8"/><path d="M5 27h38" stroke-width="1.4"/></svg>',
    dik:         '<svg width="30" height="21" viewBox="0 0 48 32" fill="none"><rect x="7" y="7" width="34" height="16" rx="2.5" stroke-width="1.8"/><path d="M5 27h38" stroke-width="1.4"/><path d="M7 15h34" stroke-width="1.2"/></svg>',

    katoen:     '<svg width="26" height="19" viewBox="0 0 48 32" fill="none"><path d="M6 12c6-6 12 6 18 0s12 6 18 0" stroke-width="1.8"/><path d="M6 22c6-6 12 6 18 0s12 6 18 0" stroke-width="1.8"/></svg>',
    satijn:     '<svg width="26" height="19" viewBox="0 0 48 32" fill="none"><path d="M8 25C14 11 34 11 40 25" stroke-width="1.8"/><path d="M24 6v4M19.5 8l2 3M28.5 8l-2 3" stroke-width="1.6"/></svg>',
    percale:    '<svg width="26" height="19" viewBox="0 0 48 32" fill="none"><rect x="10" y="8" width="28" height="16" rx="1.5" stroke-width="1.8"/><path d="M10 13.5h28M10 18.5h28M19 8v16M28 8v16" stroke-width="1.1"/></svg>',
    flanel:     '<svg width="26" height="19" viewBox="0 0 48 32" fill="none"><path d="M14 26c-4-6 4-8 0-14M24 26c-4-6 4-8 0-14M34 26c-4-6 4-8 0-14" stroke-width="1.8"/></svg>',
    jersey:     '<svg width="26" height="19" viewBox="0 0 48 32" fill="none"><path d="M15 16h18" stroke-width="1.8"/><path d="M19 11l-5 5 5 5M29 11l5 5-5 5" stroke-width="1.8"/></svg>',
    lyocell:    '<svg width="26" height="19" viewBox="0 0 48 32" fill="none"><path d="M24 26C14 26 12 14 24 6c12 8 10 20 0 20Z" stroke-width="1.8"/><path d="M24 26V15" stroke-width="1.4"/></svg>',
    tetra:      '<svg width="26" height="19" viewBox="0 0 48 32" fill="none"><path d="M14 22a6 6 0 1 1 2-11 8 8 0 0 1 15-1 6 6 0 0 1 3 12H14Z" stroke-width="1.8"/></svg>',
    seersucker: '<svg width="26" height="19" viewBox="0 0 48 32" fill="none"><path d="M8 11c3 3 5-3 8 0s5-3 8 0 5-3 8 0 5-3 8 0" stroke-width="1.6"/><path d="M8 18c3 3 5-3 8 0s5-3 8 0 5-3 8 0 5-3 8 0" stroke-width="1.6"/><path d="M8 25c3 3 5-3 8 0s5-3 8 0 5-3 8 0 5-3 8 0" stroke-width="1.6"/></svg>',
    velours:    '<svg width="26" height="19" viewBox="0 0 48 32" fill="none"><path d="M10 22c4-10 8 6 12-4s8 6 12-4 6 4 4 8" stroke-width="1.8"/></svg>',
    bamboe:     '<svg width="26" height="19" viewBox="0 0 48 32" fill="none"><path d="M20 5v22M28 5v22" stroke-width="1.8"/><path d="M16 11h8M16 21h8M24 15h8M24 25h8" stroke-width="1.3"/></svg>',
    molton:     '<svg width="26" height="19" viewBox="0 0 48 32" fill="none"><rect x="9" y="10" width="30" height="13" rx="3" stroke-width="1.8"/><path d="M15 14v5M24 14v5M33 14v5" stroke-width="1.3"/></svg>',
    waterdicht: '<svg width="26" height="19" viewBox="0 0 48 32" fill="none"><path d="M24 5c6 8 9 12 9 16a9 9 0 0 1-18 0c0-4 3-8 9-16Z" stroke-width="1.8"/></svg>',

    seizoenen:  '<svg width="25" height="25" viewBox="0 0 48 48" fill="none"><path d="M24 7v34M7 24h34" stroke-width="1.4" stroke-linecap="round"/><path d="M16 15a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Z" stroke-width="1.6"/><circle cx="33" cy="13" r="3.5" stroke-width="1.6"/><path d="M33 6.5v2.5M33 17v2.5M26.5 13h2.5M37 13h2.5" stroke-width="1.4" stroke-linecap="round"/><path d="M14 34c3.5-1.8 6.5 0 7.5 3.5-3.5 1-5.5 0-7.5-3.5Z" stroke-width="1.6" stroke-linecap="round"/><path d="M33 29v10M28 34h10M29.5 31.5l7 5M36.5 31.5l-7 5" stroke-width="1.5" stroke-linecap="round"/></svg>',
    lenteherfst:'<svg width="25" height="25" viewBox="0 0 48 48" fill="none"><path d="M24 9v30" stroke-width="1.4" stroke-linecap="round"/><circle cx="16" cy="20" r="3.5" stroke-width="1.6"/><path d="M16 12.5v3M11.5 20h3M16 27.5v-3M20.5 20h-3" stroke-width="1.4" stroke-linecap="round"/><path d="M30 18c4 0 7 3 7 7-4 0-7-3-7-7Z" stroke-width="1.6" stroke-linecap="round"/><path d="M30 18c0 4-2 7-6 7" stroke-width="1.5" stroke-linecap="round"/></svg>',
    winter:     '<svg width="25" height="25" viewBox="0 0 48 48" fill="none"><path d="M24 9v30M12 24h24M17 17l14 14M31 17L17 31" stroke-width="1.6" stroke-linecap="round"/><path d="M24 9l-3 3M24 9l3 3M24 39l-3-3M24 39l3-3M12 24l3-3M12 24l3 3M36 24l-3-3M36 24l-3 3" stroke-width="1.4" stroke-linecap="round"/></svg>',
    zomer:      '<svg width="25" height="25" viewBox="0 0 48 48" fill="none"><circle cx="24" cy="24" r="6.5" stroke-width="1.7"/><path d="M24 9v5M24 34v5M9 24h5M34 24h5M14 14l3.5 3.5M30.5 30.5L34 34M14 34l3.5-3.5M30.5 17.5L34 14" stroke-width="1.5" stroke-linecap="round"/></svg>'
  };

  var CHECK  = '<svg width="9" height="7" viewBox="0 0 10 8" fill="none"><path d="M1 4l2.6 2.6L9 1.2" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHEVRON= '<svg width="11" height="7" viewBox="0 0 12 8" fill="none"><path d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ARROW  = '<svg width="11" height="9" viewBox="0 0 12 10" fill="none"><path d="M1 5h9M6.5 1.5L10 5l-3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ==========================================================
     START
     ========================================================== */

  var cfg = window.BTOL_WIZARD;
  var mount = document.getElementById('btol-wiz');

  if (!cfg || !mount) {
    if (mount && mount.parentNode) mount.parentNode.removeChild(mount);
    return;
  }

  var forcedStep = null;
  var built = [];
  var bar = null;

  /* ---------- URL ---------- */

  function params() {
    return new URL(window.location.href).searchParams;
  }

  function state() {
    var s = {};
    params().forEach(function (v, k) {
      if (!(k in s)) s[k] = v;
    });
    return s;
  }

  /* Regel { key: [toegelaten waarden] }.
     Staat de sleutel nog niet in de URL, dan oordelen we niet. */
  function allowed(rule, st) {
    if (!rule) return true;
    var keys = Object.keys(rule);
    for (var i = 0; i < keys.length; i++) {
      var v = st[keys[i]];
      if (v == null) continue;
      if (rule[keys[i]].indexOf(v) === -1) return false;
    }
    return true;
  }

  /* ---------- overgeslagen stappen ---------- */

  function skipped() {
    try { return JSON.parse(sessionStorage.getItem(SKIP_KEY) || '{}'); }
    catch (e) { return {}; }
  }

  function setSkipped(id, val) {
    var s = skipped();
    if (val) s[id] = 1; else delete s[id];
    try { sessionStorage.setItem(SKIP_KEY, JSON.stringify(s)); } catch (e) {}
  }

  function isSkipped(step, st) {
    if (!allowed(step.skipUnless, st)) return true;
    if (skipped()[step.id]) return true;
    return false;
  }

  function computeStep() {
    if (forcedStep !== null) return forcedStep;
    var st = state();
    for (var i = 0; i < cfg.steps.length; i++) {
      var s = cfg.steps[i];
      if (isSkipped(s, st)) continue;
      if (!st[s.doneKey]) return i;
    }
    return cfg.steps.length - 1;
  }

  /* ---------- filterbalk uitlezen ---------- */

  function norm(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function findFacet(key, label) {
    try {
      var inputs = Array.prototype.slice.call(document.querySelectorAll('input[name="' + key + '"]'));
      if (!inputs.length) return null;

      var target = norm(label);

      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i], text = '';
        if (input.id) {
          var sel = (window.CSS && CSS.escape) ? CSS.escape(input.id) : input.id;
          var l = document.querySelector('label[for="' + sel + '"]');
          if (l) text = l.textContent;
        }
        if (!text && input.closest('label')) text = input.closest('label').textContent;
        text = String(text || '').replace(/\(\d+\)/g, '').trim();
        if (norm(text) === target) return input.value;
      }
      return null;
    } catch (e) {
      return null;
    }
  }

  function cardValues(step, card) {
    if (!step.facetKey) return card.set || {};
    var o = {};
    o[step.facetKey] = [findFacet(step.facetKey, card.facet) || card.fallback || card.facet];
    return o;
  }

  function cardActive(step, card) {
    var values = cardValues(step, card);
    var p = params(), ok = true, any = false;

    Object.keys(values).forEach(function (key) {
      any = true;
      var current = p.getAll(key);

      if (step.multi) {
        // meerkeuze: actief zodra al zijn waarden erbij staan, ook naast andere
        values[key].forEach(function (v) {
          if (current.indexOf(v) === -1) ok = false;
        });
        return;
      }

      if (current.length !== values[key].length) { ok = false; return; }
      values[key].forEach(function (v) {
        if (current.indexOf(v) === -1) ok = false;
      });
    });

    return any && ok;
  }

  /* ---------- scrollen ---------- */

  function breath() {
    // Ademruimte boven de filterbalk. Live bijstellen kan met
    //   sessionStorage.setItem('btol_gap', 24)   in de console.
    try {
      var s = sessionStorage.getItem('btol_gap');
      if (s !== null && s !== '' && !isNaN(+s)) return +s;
    } catch (e) {}
    return (cfg.scrollBreath != null) ? cfg.scrollBreath : SCROLL_BREATH;
  }

  function trace() {
    try { if (sessionStorage.getItem('btol_trace') !== '1') return; } catch (e) { return; }
    console.log.apply(console, ['[btol]'].concat(Array.prototype.slice.call(arguments)));
  }

  /* Zelf opmeten wat er bovenaan het scherm plakt. */
  function stickyOffset() {
    var max = 0;
    var candidates = document.querySelectorAll(
      'header, sticky-header, #shopify-section-header, .header-wrapper, ' +
      '.shopify-section-group-header-group, [data-sticky-header], .header'
    );

    Array.prototype.forEach.call(candidates, function (el) {
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      if (cs.visibility === 'hidden' || cs.display === 'none') return;

      var r = el.getBoundingClientRect();
      // alleen meetellen als hij echt bovenaan het scherm plakt
      if (r.height > 0 && r.top <= 2 && r.bottom > 0) max = Math.max(max, r.bottom);
    });

    return max;
  }

  /* Hoeveel wordt er bovenaan afgedekt?

     Prestige publiceert dit zelf. In sections/header.liquid staat een
     <height-observer variable="header"> die --header-height continu bijhoudt,
     en :root krijgt --header-is-sticky mee uit de themabeslissing.

     Belangrijk: een plakkende announcement bar duwt de header naar beneden
     (zie de `top: calc(...)` regel in header.liquid), dus die hoogte telt mee.
     Is de bar niet plakkend, dan scrolt hij weg en telt hij niet.

     Deze waarden hangen niet af van waar je staat op de pagina. Dat is precies
     waarom dit werkt: zelf meten gaf bij scrollY 0 een ander antwoord dan na
     de scroll, en dáár kwam het heen-en-weer springen vandaan. */
  function headerOffset() {
    var cs = getComputedStyle(document.documentElement);

    function num(name) {
      var v = parseFloat(cs.getPropertyValue(name));
      return isNaN(v) ? 0 : v;
    }

    // header die zichzelf verbergt bij naar beneden scrollen dekt niets af
    var hides = !!document.querySelector('x-header[hide-on-scroll]');
    var header = (num('--header-is-sticky') && !hides) ? num('--header-height') : 0;
    var bar = num('--announcement-bar-is-sticky') ? num('--announcement-bar-height') : 0;

    var total = header + bar;
    if (total > 0) return { px: total, bron: 'thema (' + header + ' header + ' + bar + ' bar)' };

    return { px: stickyOffset(), bron: 'zelf gemeten' };
  }

  /* Doel: de onderkant van de wizard net boven beeld, zodat je precies op de
     filterbalk landt. De wizard staat pal boven die balk en is ons eigen
     element — dus geen enkele selector van het thema nodig. */
  function targetY() {
    var r = mount.getBoundingClientRect();
    if (!r.height) return null;

    var h = headerOffset();
    var y = Math.max(0, Math.round(window.scrollY + r.bottom - h.px - breath()));

    trace('meting:', {
      scrollY: Math.round(window.scrollY),
      wizardOnder: Math.round(r.bottom),
      header: Math.round(h.px) + ' (' + h.bron + ')',
      ademruimte: breath(),
      doel: y,
      paginaHoogte: document.body.scrollHeight
    });

    return y;
  }

  function scrollToResults(behavior) {
    var y = targetY();
    if (y === null) return false;
    window.scrollTo({ top: y, behavior: behavior || 'smooth' });
    return true;
  }

  /* Wachten tot de layout klaar is.
     Twee dingen bewegen nog na de herlading. Je filters bouwen het grid pas na
     het laden op, dus de pagina is eerst te kort om ergens naartoe te scrollen.
     En de wizard hertekent zodra de filterbalk er is: stofkaarten zonder
     producten verdwijnen, waardoor het paneel krimpt en alles eronder omhoog
     schuift.

     We kijken daarom naar de hoogte van de pagina en de hoogte van de wizard.
     Blijven die twee keer na elkaar gelijk, dan ligt de layout vast. Allebei
     altijd beschikbaar, dus dit werkt ongeacht hoe je filters in elkaar zitten. */
  function whenLayoutReady(done) {
    var last = null;
    var stable = 0;
    var tries = 0;

    (function tick() {
      // op tientallen afronden: kleine ruis mag de teller niet resetten
      var sig = Math.round(document.body.scrollHeight / 10)
              + ':' + Math.round(mount.getBoundingClientRect().height);

      if (sig === last) stable++; else stable = 0;
      last = sig;

      if (stable >= 2) { trace('layout stabiel na', tries, 'checks —', sig); done(); return; }
      if (++tries < 45) { setTimeout(tick, 150); return; }  // max ~7s
      trace('layout nooit stabiel geworden, toch scrollen —', sig);
      done();
    })();
  }

  /* Na het scrollen kan de layout nog één keer verschuiven, omdat je header
     wegklapt zodra je naar beneden gaat. Daarom nog een paar correcties,
     allemaal smooth zodat je geen sprong ziet. Scrollt de bezoeker zelf, dan
     laten we onmiddellijk los. */
  function settleScroll() {
    var passes = 0;
    var aborted = false;

    function letGo() { aborted = true; }

    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, letGo, { passive: true, once: true });
    });

    (function tick() {
      if (aborted) { trace('bezoeker scrollt zelf, losgelaten'); return; }

      var y = targetY();
      if (y === null) return;

      var delta = y - window.scrollY;
      trace('pass', passes + 1, '| nu', Math.round(window.scrollY), '-> doel', y, '| verschil', Math.round(delta));

      if (Math.abs(delta) > 4) {
        window.scrollTo({ top: y, behavior: 'smooth' });
      }

      if (++passes < 4) setTimeout(tick, 450);
      else trace('klaar op', Math.round(window.scrollY));
    })();
  }

  function restoreScroll() {
    if (sessionStorage.getItem(SCROLL_KEY) !== '1') return;
    sessionStorage.removeItem(SCROLL_KEY);
    whenLayoutReady(settleScroll);
  }

  /* Bij een tussenstap onthouden we niet de ruwe scrollpositie, maar hoe
     hoog de wizard in beeld stond. Stappen verschillen in hoogte, dus zo
     staat hij na de herlading op exact dezelfde plek op je scherm. */

  function rememberPosition() {
    try {
      sessionStorage.setItem(POS_KEY, String(mount.getBoundingClientRect().top));
    } catch (e) {}
  }

  function restorePosition() {
    var saved = sessionStorage.getItem(POS_KEY);
    if (saved === null) return;
    sessionStorage.removeItem(POS_KEY);

    var offset = parseFloat(saved);
    if (isNaN(offset)) return;

    var apply = function () {
      var absolute = mount.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: Math.max(absolute - offset, 0), behavior: 'auto' });
    };

    apply();

    // lettertypes boven de wizard kunnen de layout nog een tik verschuiven,
    // dus één stille hercorrectie zolang de bezoeker zelf nog niet scrolt
    var touched = false;
    var mark = function () { touched = true; };
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, mark, { once: true, passive: true });
    });

    window.addEventListener('load', function () {
      setTimeout(function () { if (!touched) apply(); }, 100);
    }, { once: true });
  }

  function navigate(p, doScroll) {
    var qs = p.toString();
    var url = window.location.pathname + (qs ? '?' + qs : '');

    // demo:true in de config -> geen herlading, alleen de URL bijwerken.
    // Wordt gebruikt door preview.html, staat nooit aan op de winkel.
    if (cfg.demo) {
      history.pushState({}, '', url);
      return;
    }

    if (doScroll) sessionStorage.setItem(SCROLL_KEY, '1');
    else rememberPosition();

    mount.classList.add('is-loading');
    window.location.href = url;
  }

  /* Meerkeuze: klikken zet een waarde aan of uit, de rest blijft staan.
     Anders dan choose() wist dit niets van latere stappen — een meerkeuzestap
     is bij ons altijd de laatste. */
  function toggle(values, doScroll) {
    var p = params();
    p.delete('page');
    markUsed();

    Object.keys(values).forEach(function (key) {
      var current = p.getAll(key);
      var vals = values[key];

      var has = vals.every(function (v) { return current.indexOf(v) !== -1; });

      var next = has
        ? current.filter(function (v) { return vals.indexOf(v) === -1; })
        : current.concat(vals.filter(function (v) { return current.indexOf(v) === -1; }));

      p.delete(key);
      next.forEach(function (v) { p.append(key, v); });
    });

    if (cfg.availability !== false) p.set(AVAIL_KEY, '1');
    navigate(p, doScroll);
  }

  function choose(index, values, doScroll) {
    var p = params();

    // sta je op pagina 3 en verander je een filter, dan bestaat pagina 3
    // daarna misschien niet meer -> altijd terug naar pagina 1
    p.delete('page');
    markUsed();

    // alles na deze stap vervalt: nooit een onmogelijke combinatie
    for (var i = index; i < cfg.steps.length; i++) {
      var s = cfg.steps[i];
      p.delete(s.doneKey);
      setSkipped(s.id, false);
      if (s.custom) s.custom.fields.forEach(function (f) { p.delete(f.key); });
    }

    Object.keys(values).forEach(function (key) {
      p.delete(key);
      values[key].forEach(function (v) { p.append(key, v); });
    });

    // availability:false in de config zet dit uit voor die collectie
    if (cfg.availability !== false) p.set(AVAIL_KEY, '1');

    navigate(p, doScroll);
  }

  /* ==========================================================
     WINKELWAGEN-ATTRIBUUT

     Zodra iemand de keuzehulp gebruikt, zetten we zijn keuzes als attribuut
     op de winkelwagen. Bestelt hij later, dan staat het bij Aanvullende
     gegevens op de bestelling — en kan je er in Flow, Klaviyo of Matrixify op
     filteren.

     Niet tijdens het klikken posten: dan herlaadt de pagina en breekt het
     verzoek af. We doen het ná de herlading, als de wizard toch al klaar staat.
     ========================================================== */

  function summaryText() {
    var st = state();
    var parts = [];

    cfg.steps.forEach(function (step, i) {
      if (!st[step.doneKey]) return;
      var s = summaryFor(step, built[i], st);
      if (s) parts.push(s);
    });

    if (!parts.length) return null;

    var label = cfg.label
      || decodeURIComponent(window.location.pathname.split('/collections/')[1] || 'collectie').split('/')[0];

    return label + ': ' + parts.join(' · ');
  }

  function sendCartAttribute() {
    if (cfg.demo || cfg.trackCart === false) return;

    try {
      if (sessionStorage.getItem(USED_KEY) !== '1') return;
    } catch (e) { return; }

    var text = summaryText();
    if (!text) return;

    // niet elke render opnieuw posten
    var last = null;
    try { last = sessionStorage.getItem(SENT_KEY); } catch (e) {}
    if (last === text) return;

    var attrs = {};
    attrs[cfg.cartAttribute || '_keuzehulp'] = text;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) {
      if (!r.ok) throw new Error('status ' + r.status);
      try { sessionStorage.setItem(SENT_KEY, text); } catch (e) {}
      trace('winkelwagen-attribuut gezet:', text);
    }).catch(function (e) {
      trace('winkelwagen-attribuut mislukt:', e);
    });
  }

  function markUsed() {
    try { sessionStorage.setItem(USED_KEY, '1'); } catch (e) {}
  }

  /* ==========================================================
     DOM
     ========================================================== */

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function buildCard(step, card, index) {
    var cls = 'btol-card';
    if (step.layout === 'sizes') cls += ' btol-card--size';

    var node = el('button', cls);
    node.type = 'button';

    node.appendChild(el('span', 'btol-card__check', CHECK));

    if (card.icon && ICONS[card.icon]) {
      node.appendChild(el('span', 'btol-card__icon', ICONS[card.icon]));
    }
    node.appendChild(el('span', 'btol-card__label', card.label));
    if (card.sub) node.appendChild(el('span', 'btol-card__sub', card.sub));

    node._card = card;

    node.addEventListener('click', function () {
      if (step.multi) {
        // eerste keuze: naar de resultaten. daarna blijf je staan, anders
        // moet je voor elk extra materiaal weer omhoog scrollen
        var first = params().getAll(step.doneKey).length === 0;
        node.classList.toggle('is-picked');
        toggle(cardValues(step, card), !!step.scroll && first);
        return;
      }

      if (node.classList.contains('is-active')) {
        forcedStep = null;
        render();
        return;
      }
      // meteen feedback, dan pas de herlading
      node.classList.add('is-picked');
      choose(index, cardValues(step, card), !!step.scroll);
    });

    return node;
  }

  function buildStep(step, index) {
    var row = el('div', 'btol-wiz__row');

    var q = el('h2', 'btol-wiz__q', step.question + (step.hint ? '<em>' + step.hint + '</em>' : ''));
    row.appendChild(q);

    var layout = step.layout === 'two' ? ' btol-wiz__cards--two'
               : step.layout === 'sizes' ? ' btol-wiz__cards--sizes' : '';
    var cards = el('div', 'btol-wiz__cards' + layout);

    var nodes = [];
    step.cards.forEach(function (c) {
      var n = buildCard(step, c, index);
      cards.appendChild(n);
      nodes.push(n);
    });
    row.appendChild(cards);

    // extra kaarten in een foldout
    var fold = null, foldBtn = null, foldLabel = null;
    if (step.more && step.more.length) {
      fold = el('div', 'btol-fold btol-fold--grid');
      step.more.forEach(function (c) {
        var n = buildCard(step, c, index);
        fold.appendChild(n);
        nodes.push(n);
      });
      row.appendChild(fold);
    }

    // maatinvoer
    var custom = null, customBtn = null, customLabel = null, selects = [];
    if (step.custom) {
      custom = el('div', 'btol-fold');
      var box = el('div', 'btol-custom');

      step.custom.fields.forEach(function (f) {
        var field = el('div', 'btol-custom__field');
        var id = 'btol-f-' + f.key.replace(/[^a-z]/gi, '');
        var lab = el('label', null, f.label);
        lab.setAttribute('for', id);

        var sel = document.createElement('select');
        sel.id = id;
        f.options.forEach(function (o) {
          var opt = document.createElement('option');
          opt.value = o;
          opt.textContent = o;
          if (o === f.def) opt.selected = true;
          sel.appendChild(opt);
        });

        field.appendChild(lab);
        field.appendChild(sel);
        box.appendChild(field);
        selects.push({ key: f.key, node: sel });
      });

      var go = el('button', 'btol-custom__go', step.custom.go);
      go.type = 'button';
      go.addEventListener('click', function () {
        var vals = {};
        selects.forEach(function (s) { vals[s.key] = [s.node.value]; });
        choose(index, vals, !!step.scroll);
      });
      box.appendChild(go);
      custom.appendChild(box);
      row.appendChild(custom);
    }

    // onderbalk
    var foot = el('div', 'btol-wiz__foot');
    var hasFoot = false;

    if (fold) {
      foldBtn = el('button', 'btol-link');
      foldBtn.type = 'button';
      foldLabel = el('span', null, step.moreLabel[0]);
      foldBtn.appendChild(foldLabel);
      foldBtn.insertAdjacentHTML('beforeend', CHEVRON);
      foldBtn.addEventListener('click', function () {
        var open = fold.classList.toggle('is-open');
        foldBtn.classList.toggle('is-open', open);
        foldLabel.textContent = step.moreLabel[open ? 1 : 0];
      });
      foot.appendChild(foldBtn);
      hasFoot = true;
    }

    if (custom) {
      customBtn = el('button', 'btol-link');
      customBtn.type = 'button';
      customLabel = el('span', null, step.custom.toggleLabel[0]);
      customBtn.appendChild(customLabel);
      customBtn.insertAdjacentHTML('beforeend', CHEVRON);
      customBtn.addEventListener('click', function () {
        var open = custom.classList.toggle('is-open');
        customBtn.classList.toggle('is-open', open);
        customLabel.textContent = step.custom.toggleLabel[open ? 1 : 0];
      });
      foot.appendChild(customBtn);
      hasFoot = true;
    }

    if (step.skippable) {
      var skipBtn = el('button', 'btol-link', step.skipLabel || btolT('sla_over', 'Sla over'));
      skipBtn.type = 'button';
      skipBtn.addEventListener('click', function () {
        if (step.scroll) {
          settleScroll();
        } else {
          setSkipped(step.id, true);
          forcedStep = null;
          render();
        }
      });
      foot.appendChild(skipBtn);
      hasFoot = true;
    }

    if (hasFoot) row.appendChild(foot);

    // cross-sell
    var cross = null, crossLinks = [];
    if (step.cross) {
      cross = el('div', 'btol-cross');
      cross.appendChild(el('span', 'btol-cross__text', step.cross.text));
      step.cross.links.forEach(function (l) {
        var a = el('a', null, l.label + ARROW);
        a.href = l.url;
        cross.appendChild(a);
        crossLinks.push({ node: a, url: l.url });
      });
      row.appendChild(cross);
    }

    return {
      row: row, step: step, cards: nodes,
      fold: fold, foldBtn: foldBtn, foldLabel: foldLabel,
      custom: custom, selects: selects,
      cross: cross, crossLinks: crossLinks
    };
  }

  function build() {
    bar = el('div', 'btol-wiz__bar');
    mount.appendChild(bar);

    var panel = el('div', 'btol-wiz__panel');

    // stepper
    var steps = el('div', 'btol-wiz__steps');
    cfg.steps.forEach(function (step, i) {
      if (i > 0) {
        var sep = el('span', 'btol-wiz__sep');
        steps.appendChild(sep);
        step._sep = sep;
      }

      var item = el('button', 'btol-wiz__step');
      item.type = 'button';

      var badge = el('span', 'btol-wiz__badge', '<span>' + (i + 1) + '</span>' + CHECK);
      var text  = el('span', 'btol-wiz__steptext');
      var name  = el('span', 'btol-wiz__stepname', step.name);
      var value = el('span', 'btol-wiz__stepvalue');

      text.appendChild(name);
      text.appendChild(value);
      item.appendChild(badge);
      item.appendChild(text);

      item.addEventListener('click', function () {
        if (!item.classList.contains('is-done')) return;
        forcedStep = i;
        render();
      });

      steps.appendChild(item);
      step._item = item;
      step._value = value;
    });
    panel.appendChild(steps);

    cfg.steps.forEach(function (step, i) {
      var b = buildStep(step, i);
      panel.appendChild(b.row);
      built.push(b);
    });

    mount.appendChild(panel);
    mount.classList.add('is-ready');
  }

  /* ==========================================================
     WEERGEVEN
     ========================================================== */

  function summaryFor(step, b, st) {
    // vaste samenvatting uit meerdere sleutels, bv. "160 x 200"
    if (step.summaryKeys) {
      var parts = step.summaryKeys.map(function (k) {
        return st[k] ? String(st[k]).replace(/\s*cm\s*$/i, '') : null;
      }).filter(Boolean);
      if (parts.length) return parts.join(step.summaryJoin || ' x ');
    }

    // anders: de labels van de gekozen kaarten
    var labels = [];
    for (var i = 0; i < b.cards.length; i++) {
      if (b.cards[i].classList.contains('is-active')) labels.push(b.cards[i]._card.label);
    }
    if (labels.length) return labels.join(', ');

    return st[step.doneKey] || '';
  }

  function render() {
    var active = computeStep();
    var st = state();

    built.forEach(function (b, i) {
      b.row.classList.toggle('is-visible', i === active);
    });

    // kaarten
    built.forEach(function (b) {
      var step = b.step;
      var haveFacets = step.facetKey
        ? document.querySelectorAll('input[name="' + step.facetKey + '"]').length > 0
        : false;
      var openFold = false;

      b.cards.forEach(function (node) {
        var card = node._card;
        var isActive = cardActive(step, card);

        node.classList.toggle('is-active', isActive);
        if (!isActive) node.classList.remove('is-picked');

        var hide = false;
        if (!allowed(card.hideUnless, st)) hide = true;
        // stof die niet in de filterbalk staat, bestaat hier niet
        if (step.facetKey && haveFacets && !isActive && !findFacet(step.facetKey, card.facet)) hide = true;
        node.classList.toggle('is-hidden', hide);

        if (isActive && b.fold && b.fold.contains(node)) openFold = true;
      });

      if (openFold && b.fold && !b.fold.classList.contains('is-open')) {
        b.fold.classList.add('is-open');
        if (b.foldBtn) b.foldBtn.classList.add('is-open');
        if (b.foldLabel) b.foldLabel.textContent = step.moreLabel[1];
      }

      // dropdowns op de gekozen maat zetten
      b.selects.forEach(function (s) {
        if (st[s.key]) s.node.value = st[s.key];
      });

      // cross-sell met de maat mee
      if (b.cross) {
        var carry = step.cross.carry.filter(function (k) { return st[k]; });
        var show = carry.length > 0;
        b.cross.classList.toggle('is-visible', show);

        if (show) {
          var q = new URLSearchParams();
          q.set(AVAIL_KEY, '1');
          carry.forEach(function (k) { q.append(k, st[k]); });
          var qs = '?' + q.toString();
          b.crossLinks.forEach(function (l) { l.node.href = l.url + qs; });
        }
      }
    });

    // stepper
    var visibleIndex = 0;
    cfg.steps.forEach(function (step, i) {
      var skip = isSkipped(step, st) && !st[step.doneKey];
      var done = !!st[step.doneKey] && i !== active;

      step._item.classList.toggle('is-hidden', skip);
      if (step._sep) step._sep.classList.toggle('is-hidden', skip);

      step._item.classList.toggle('is-current', i === active);
      step._item.classList.toggle('is-done', done);
      step._value.textContent = done ? summaryFor(step, built[i], st) : '';

      if (!skip) {
        step._item.querySelector('.btol-wiz__badge span').textContent = ++visibleIndex;
      }
    });

    mount.classList.remove('is-loading');
  }

  /* ==========================================================
     INIT
     ========================================================== */

  function hookHistory() {
    try {
      var fire = function () { window.dispatchEvent(new Event('btol:urlchange')); };

      ['pushState', 'replaceState'].forEach(function (fn) {
        var original = history[fn];
        history[fn] = function () {
          var r = original.apply(this, arguments);
          fire();
          return r;
        };
      });

      window.addEventListener('popstate', fire);

      var timer;
      window.addEventListener('btol:urlchange', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { forcedStep = null; render(); }, 50);
      });
    } catch (e) {}
  }

  try { history.scrollRestoration = 'manual'; } catch (e) {}

  /* Meetpunt voor als de scroll niet klopt. In de console:
       BTOL_DEBUG.info()      -> alles wat de berekening gebruikt
       BTOL_DEBUG.headers()   -> welke elementen als plakkende header tellen
       BTOL_DEBUG.go()        -> nu opnieuw scrollen                          */
  window.BTOL_DEBUG = {
    version: VERSION,

    info: function () {
      var r = mount.getBoundingClientRect();
      var h = headerOffset();
      return {
        versie: VERSION,
        scrollY: Math.round(window.scrollY),
        wizardOnderInBeeld: Math.round(r.bottom),
        wizardHoogte: Math.round(r.height),
        header: Math.round(h.px),
        headerBron: h.bron,
        zelfGemetenTerVergelijking: Math.round(stickyOffset()),
        ademruimte: breath(),
        berekendDoel: targetY(),
        paginaHoogte: document.body.scrollHeight,
        maxScroll: Math.round(document.body.scrollHeight - window.innerHeight)
      };
    },

    headers: function () {
      var out = [];
      document.querySelectorAll(
        'header, sticky-header, #shopify-section-header, .header-wrapper, ' +
        '.shopify-section-group-header-group, [data-sticky-header]'
      ).forEach(function (el) {
        var cs = window.getComputedStyle(el);
        var r = el.getBoundingClientRect();
        out.push({
          el: el.tagName + (el.id ? '#' + el.id : ''),
          positie: cs.position,
          top: Math.round(r.top),
          onder: Math.round(r.bottom),
          hoogte: Math.round(r.height),
          teltMee: (cs.position === 'sticky' || cs.position === 'fixed')
                   && r.height > 0 && r.top <= 2 && r.bottom > 0
        });
      });
      return out;
    },

    go: function () { settleScroll(); }
  };

  build();
  hookHistory();
  render();

  // meteen na build(): de wizard is nu zichtbaar en dus meetbaar
  restorePosition();
  restoreScroll();

  document.addEventListener('DOMContentLoaded', render);
  setTimeout(render, 400);
  setTimeout(function () { render(); sendCartAttribute(); }, 1200);
})();